import React from 'react';
import { connect } from 'react-redux';
import { Route, Redirect } from 'react-router-dom';
import PropTypes from 'prop-types';
import { path } from '../conf/route.conf';

const routeIsInWhitelist = ({ whitelistPages, pathname }) => whitelistPages.find(page => page === pathname);

/**
 * Render the component when the pathname is in the whitelist or redirect to first step.
 * @param Component
 * @param access
 * @param rest
 * @return {*}
 * @constructor
 */
const ProtectedRoute = ({
  component: Component, whitelistPages, pathname, ...rest
}) => (
  <Route
    {...rest}
    render={props => (routeIsInWhitelist({ whitelistPages, pathname }) ? <Component {...props} /> : <Redirect to={path.LOGIN} />)}
  />
);

ProtectedRoute.propTypes = {
  /** React component to render */
  component: PropTypes.oneOfType([
    PropTypes.element,
    PropTypes.func,
  ]).isRequired,
  /** Pathname of the current route */
  pathname: PropTypes.string.isRequired,
  /** List of whitelist pages where user can access to */
  whitelistPages: PropTypes.arrayOf(PropTypes.string).isRequired,
};

const mapStateToProps = state => ({
  pathname: state.router.location.pathname,
  whitelistPages: state.generic.whitelistPages,
});

export default connect(
  mapStateToProps,
)(ProtectedRoute);
